import React from 'react';

const AuthProviderContext = React.createContext(null);

export const AuthProvider = AuthProviderContext.Provider;

export const useAuthProvider = () => {
  return React.useContext(AuthProviderContext);
};
